
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const vec: IProductData = {
  id: "hazelriggindustries-vec",
  name: "Hazelrigg Industries VEC",
  description: "The Everything Channel: VLC, VNE, & VPH",
  specialOrder: true,
  images: ["/img/hazelriggindustries_vec_front.png"],
  details: [{
    label: "Description",
    markdown: `
The Everything Chain by Hazelrigg Industries is a complete audio chain ideal for tracking, mixing and live sound.  
This specially priced bundle include the famed VLC All-Tube Mic Preamp/Line Processor/EQ/DI, the extraordinary VNE All-Tube, single-channel, Pulse Width Modulation (PWM) compressor and the oh-so-stylish VPH matching vented rack panel to keep the gear cool while the rack looks hot.  
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/everything-chain" target="_blank">https://www.hazelriggindustries.com/everything-chain</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/nCXLukfMXf4?si=IOc6gKJk5BavJdbC"],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.RACK, HASHTAGS.FIVE_U, HASHTAGS.EQ, HASHTAGS.COMPRESSOR, HASHTAGS.MICPRE],
    manufacturer: BRAND.HAZELRIGG,
  }
}